import React from 'react';

const DepartmentFilterIcon = (props: any) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16 6.25H4C3.17157 6.25 2.5 6.92157 2.5 7.75V15.25C2.5 16.0784 3.17157 16.75 4 16.75H16C16.8284 16.75 17.5 16.0784 17.5 15.25V7.75C17.5 6.92157 16.8284 6.25 16 6.25Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13 16.75V4.75C13 4.35218 12.842 3.97064 12.5607 3.68934C12.2794 3.40804 11.8978 3.25 11.5 3.25H8.5C8.10218 3.25 7.72064 3.40804 7.43934 3.68934C7.15804 3.97064 7 4.35218 7 4.75V16.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default DepartmentFilterIcon;
